import { TieredMenuDesignTokens } from '@primeuix/themes/aura/tieredmenu';

export const tieredMenuTokens: TieredMenuDesignTokens = {
  root: {
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    color: '{color.main.primary}',
    shadow: '{overlay.navigation.shadow}',
    transitionDuration: '{transition.duration}',
  },
  list: {
    padding: '{navigation.list.padding}',
    gap: '{navigation.list.gap}',
  },
  item: {
    focusBackground: '{color.brand.subtle}',
    focusColor: '{color.main.primary}',
    activeBackground: '{navigation.item.active.background}',
    activeColor: '{navigation.item.active.color}',
    color: '{color.main.primary}',
    padding: '{navigation.item.padding}',
    borderRadius: '{navigation.item.border.radius}',
    gap: '{navigation.item.gap}',
    icon: {
      color: '{color.main.tertiary}',
      focusColor: '{color.main.tertiary}',
      activeColor: '{color.main.tertiary}',
    },
  },
  submenuIcon: {
    size: '{navigation.submenu.icon.size}',
    color: '{color.main.tertiary}',
    focusColor: '{color.main.tertiary}',
    activeColor: '{color.main.tertiary}',
  },
  submenu: {
    mobileIndent: '1rem',
  },
  separator: {
    borderColor: '{content.border.color}',
  },
  css: ({ dt }) => `
    .p-tieredmenu-item-link:focus, .p-tieredmenu-item-link:active, .p-tieredmenu-item-link:hover {
      color: ${dt('menu.item.focus.color')};
    }

    .p-tieredmenu-separator {
      margin: 0.25rem 0;
    }

    .p-tieredmenu-item-label {
      line-height: 1.25rem;
    }

    li.delete-menu-item {
      .p-tieredmenu-item-content,
      .p-tieredmenu-item-link,
      .p-tieredmenu-item-icon {
        color: ${dt('color.fail.main')} !important;
      }
    }
  `,
};
